import {
    CREATE_WORKER_ATTENDANCE_DAILY,
    DELETE_WORKER_ATTENDANCE_DAILY,
    GET_WORKER_ATTENDANCE_DAILY,
    WORKER_ATTENDANCE_DAILY_REQUEST,
    WORKER_ATTENDANCE_DAILY_REQUEST_FAILURE,
    UPDATE_WORKER_ATTENDANCE_DAILY
  } from "../types/worker-attendance-daily-types";
  
  const initialState = {
    workerAttendanceDaily: [],
    loading: false,
    error: null,
  };
  
  const workerAttendanceDailyReducer = (state = initialState, action) => {
    switch (action.type) {
      case WORKER_ATTENDANCE_DAILY_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_WORKER_ATTENDANCE_DAILY: {
        return {
          ...state,
          workerAttendanceDaily: [...action.payload],
          loading: false,
          error: null
        }
      }
      case CREATE_WORKER_ATTENDANCE_DAILY:
        return {
          ...state,
          workerAttendanceDaily: [action.payload, ...state.workerAttendanceDaily],
          loading: false,
          error: null
        };
      case UPDATE_WORKER_ATTENDANCE_DAILY:
        const workerAttendanceDailyData = state.workerAttendanceDaily.slice(0);
        console.log('before>>', workerAttendanceDailyData);
        const uIndex = workerAttendanceDailyData.findIndex((data) => data.id === action.payload.id);
        console.log('uIndex>>', uIndex);
        workerAttendanceDailyData.splice(uIndex, 1, { ...action.payload.data });
        console.log('after>>', workerAttendanceDailyData.splice(uIndex, 1, { ...action.payload.data }));
        
        return {
          ...state,
          workerAttendanceDaily: [ ...workerAttendanceDailyData ],
          loading: false,
          error: null
        };
      case DELETE_WORKER_ATTENDANCE_DAILY:
        const workerAttendanceDaily = state.workerAttendanceDaily?.slice(0);
        const index = workerAttendanceDaily.findIndex((data) => data.id === action.id);
        if (index > -1) {
          workerAttendanceDaily.splice(index, 1);
        }
        return {
          ...state,
          workerAttendanceDaily: [...workerAttendanceDaily],
          loading: false,
          error: null
        }
      case WORKER_ATTENDANCE_DAILY_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default workerAttendanceDailyReducer;
  